import * as React from "react";
import {
  Box,
  Button,
  Container,
  List,
  ListItem,
  ListItemButton,
  Paper,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import PostData from "../../data/Posts";
import { Helmet } from "react-helmet-async";
import { canonicalUrl } from "../../common/seo";

const HUB_PATH = "/best-trails-northwest-arkansas";

function isTrailPost(post: any) {
  const title = String(post.title || "");
  const link = String(post.link || "");
  const subTitle = String(post.subTitle || "");

  return (
    /trail/i.test(title) ||
    /trail/i.test(link) ||
    /trail/i.test(subTitle) ||
    /greenway/i.test(title) ||
    /greenway/i.test(subTitle)
  );
}

export function BestTrails() {
  const bestTrails = React.useMemo(() => {
    return PostData.filter((post) => isTrailPost(post));
  }, []);

  const title = "Best Trails in Northwest Arkansas | NWA Blog";
  const description =
    "A curated hub of the best trails in Northwest Arkansas—bike trails, walking trails, and greenway-friendly routes.";

  return (
    <Container component="section" sx={{ marginTop: "5rem" }}>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={canonicalUrl(HUB_PATH)} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl(HUB_PATH)} />
      </Helmet>

      <Paper elevation={1} sx={{ padding: "1rem", textAlign: "center" }}>
        <Typography variant="h5" sx={{ fontWeight: "bold" }}>
          Best Trails in Northwest Arkansas
        </Typography>
        <Typography variant="body2" sx={{ marginTop: ".5rem" }}>
          Quick links to trail posts.
        </Typography>
      </Paper>

      <Box sx={{ marginTop: "1rem" }}>
        <List>
          {bestTrails.map((post, i) => (
            <ListItem key={i} disablePadding sx={{ marginBottom: ".75rem" }}>
              <ListItemButton
                component={RouterLink}
                to={`/${post.link}`}
                sx={{ padding: 0 }}
              >
                <Paper
                  elevation={2}
                  sx={{
                    width: "100%",
                    border: "2px solid",
                    borderColor: "accent.main",
                    borderRadius: 3,
                    overflow: "hidden",
                  }}
                >
                  <Box sx={{ bgcolor: "accent.main", height: ".25rem" }} />
                  <Box sx={{ bgcolor: "secondary.main", height: ".5rem" }} />
                  <Box sx={{ padding: ".75rem" }}>
                    <Typography variant="h6" sx={{ color: "accent.main" }}>
                      {post.title}
                    </Typography>
                    <Typography variant="body2">{post.subTitle}</Typography>
                  </Box>
                </Paper>
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        <Typography variant="body2" sx={{ marginTop: "1rem" }}>
          Want to share a photo credit or request removal? See{" "}
          <Button
            component={RouterLink}
            to="/copyright"
            variant="outlined"
            size="small"
            sx={{
              textTransform: "none",
              color: "accent.main",
              borderColor: "accent.main",
              "&:hover": { borderColor: "accent.main" },
            }}
          >
            copyright
          </Button>
          .
        </Typography>
      </Box>
    </Container>
  );
}
